import axios from "axios";
import { createBrowserHistory } from "history";

export const history = createBrowserHistory();

/* ======================
   BASE URL
====================== */
 // const baseUrl = "http://localhost:2000/api";
const baseUrl = "http://203.175.74.144:12000/api"
const api = axios.create({
  baseURL: baseUrl,
  headers: { "Content-Type": "application/json" },
});

/* ======================
   INTERCEPTORS
====================== */
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && [401, 403].includes(error.response.status)) {
      localStorage.removeItem("token");
      history.push("/");
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

/* ======================
   AUTH
====================== */
export const requestOtpApi = async (email) => {
  const res = await api.post("/auth/request-otp", { email });
  return res.data;
};

export const verifyOtpApi = async (email, otp) => {
  const res = await api.post("/auth/verify-otp", { email, otp });
  return res.data;
};

export const resendOtpApi = async (email) => {
  const res = await api.post("/auth/resend-otp", { email });
  return res.data;
};

/* ======================
   SYSTEM / DASHBOARD
====================== */
export const getSystemDashboardStats = async () => {
  const res = await api.get("/system/dashboard-stats");
  return res.data;
};
export const getSystemDashboardChartsStats = async (range) => {
  const res = await api.get(`/system/transactions?range=${range}`);
  return res.data;
};
/* ======================
   ORGANIZATION
====================== */
export const onboardOrganization = async (payload) => {
  const res = await api.post("/org/onboard", payload);
  return res.data;
};

export const getOrgDashboardStats = async (orgId) => {
  const res = await api.get(`/org/org-dashboard?orgId=${orgId}`);
  return res.data;
};
export const getAllOrganizations = async (orgId) => {
  const res = await api.get(`/org/allorganizations`);
  return res.data;
};
export const getOrganizationStats = async (orgId) => {
  const res = await api.get(`/org/${orgId}`);
  return res.data;
};
export const updateOrganization = async (orgId, data) => {
  const response = await api.put(`/org/update/${orgId}`, data);
  return response.data;
};
export const enableOrganization = async (orgId) => {
  const response = await api.put(`/org/enable/${orgId}`);
  return response.data;
};
export const disableOrganization = async (orgId) => {
  const response = await api.put(`/org/disable/${orgId}`);
  return response.data;
};
export const deleteOrganization = async (orgId) => {
  const res = await api.delete(
    `/org/delete/${orgId}`
  );
  return res.data;
};
/* ======================
   USERS (ADMIN / ORG)
====================== */
export const getAllOrgUsers = async (orgId) => {
  const res = await api.get(`/users/allOrgUsers?orgId=${orgId}`);
  return res.data;
};

export const createUserByOrg = async (payload) => {
  const res = await api.post("/users/create", payload);
  return res.data;
};
export const deleteUserByOrg = async (userId) => {
  const res = await api.delete(`/users/${userId}`);
  return res.data;
};
export const updateUserByOrg = async (userId, data) => {
  const res = await api.patch(`/users/${userId}`, data);
  return res.data;
};
/* ======================
   AGENTS
====================== */
export const createAgent = async (payload) => {
  const res = await api.post("/agents/create", payload);
  return res.data;
};

export const getAllOrgAgents = async (orgId) => {
  const res = await api.get(`/agents/org/${orgId}`);
  return res.data;
};


export const deleteAgentByOrg = async (cnic) => {
  const res = await api.delete(`/agents/delete/${cnic}`);
  return res.data;
};
export const updateAgentByOrg = async (cnic, data) => {
  const res = await api.put(`/agents/update/${cnic}`, data);
  return res.data;
};
export const markAgentPaymentDone = async (cnic) => {
  const res = await api.put(`agents/payment-complete?cnic=${cnic}`);
  return res.data;
};
export const getAgentEarnings = async (cnic) => {
  const res = await api.get(`/agents/earnings/${cnic}`);
  return res.data;
};
export const getAgentMerchants = async (id,params) => {
  const res = await api.get(`/agents/merchants/${id}?${params}`);
  return res.data;
};
export const getAgentMerchantsStats = async (id) => {
  const res = await api.get(`/agents/stats/${id}`);
  return res.data;
};
export const getMerchantProfile = async (merchantID) => {
  console.log(`/agents/merchants/profile/${merchantID}`)
  const res = await api.get(`/agents/merchants/profile/${merchantID}`);
  return res.data;
};
export const getMerchantTransactionStats = async (merchantID) => {
  const res = await api.get(`agents/merchants/${merchantID}/stats`);
  return res.data;
};

export const getMerchantTransactions = async (merchantID, params) => {
  const res = await api.get(`agents/merchants/${merchantID}/transactions?${params}`);
  return res.data;
};
/* ======================
   PORTAL – MERCHANT / TERMINAL
====================== */
export const getMerchantTerminalStats = async () => {
  const res = await api.get("/merchant-terminal-stat");
  return res.data;
};

export const getAllMerchants = async (orgId) => {
  const res = await api.get(`/merchant/merchants-by-org/${orgId}`);
  return res.data;
};

/* ======================
   REPORTING / TXNS
====================== */
export const getReportingStats = async () => {
  const res = await api.get("/portal/reportingStats");
  return res.data;
};

export const getTotalTransactions = async () => {
  const res = await api.get("/portal/totalTransactions");
  return res.data;
};

export const getSettledTransactions = async () => {
  const res = await api.get("/portal/settledTransactions");
  return res.data;
};

export const getUnsettledTransactions = async () => {
  const res = await api.get("/portal/unsettledTransactions");
  return res.data;
};

export const getDisputedTransactions = async () => {
  const res = await api.get("/portal/disputedTransactions");
  return res.data;
};

export const getTodayTransactions = async () => {
  const res = await api.get("/portal/todayTransactions");
  return res.data;
};

/* ======================
   TERMINALS
====================== */
export const createTerminal = async (body) => {
  const res = await api.post("/createTerminal", {
    TID: body.terminalId,
    MID: body.merchantId,
    PhoneNumber: `+${body.phoneNumber}`,
    attended: body.attended,
    cardholderActivated: body.cardholderActivated,
    cardPresenceCapability: body.cardPresenceCapability,
    inputCapability: body.inputCapability,
    lane: body.lane,
    location: body.location,
    onlineReasonCode: body.onlineReasonCode,
    panEntryMode: body.panEntryMode,
    pinEntryCapability: body.pinEntryCapability,
    cards: body.cards,
    environment: body.environment,
    transactionType: body.transactionType,
  });
  return res.data;
};

export const updateTerminal = async (body) => {
  const res = await api.put(
    `/portal/updateTerminal/${body.terminalId}`,
    body
  );
  return res.data;
};

export const deleteTerminalByID = async (terminalId) => {
  const res = await api.delete(
    `/portal/deleteTerminal/${terminalId}`
  );
  return res.data;
};

/* ======================
   MERCHANT
====================== */
export const onboardMerchant = async (payload) => {
  const res = await api.post("/merchant-onboard", payload);
  return res.data;
};

export const updateMerchant = async (payload) => {
  const res = await api.put(
    `/portal/updateMerchant/${payload.MID}`,
    payload
  );
  return res.data;
};

export const deleteMerchantByID = async (MID) => {
  const res = await api.delete(`/portal/deleteMerchant/${MID}`);
  return res.data;
};

/* ======================
   PORTAL SETTINGS
====================== */
export const updateNacType = async (nacType) => {
  const res = await api.post("/portal/update-nac", { nacType });
  return res.data;
};

export const updateMessage210 = async (message210) => {
  const res = await api.post("/portal/update-message210", {
    message210,
  });
  return res.data;
};

export default api;
